import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { EProjectType } from '../../../../enum/project';
import { ELanguages, TLanguages, changeLanguage, languages } from '../../../../localization';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { ILanguageButtonProps } from './ILanguageButton';

const LanguageButton = (props: ILanguageButtonProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const projectInfo = useAppSelector(selectProjectInfo);

    const { t } = useTranslation();
    const open = Boolean(anchorEl);
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = (language: string) => {
        changeLanguage(language);
        setAnchorEl(null);
    };

    React.useEffect(() => {
        if (projectInfo.data && projectInfo.data.type !== undefined && projectInfo.data.type !== EProjectType.Macra1) {
            changeLanguage(ELanguages.en);
        }
    }, [projectInfo]);

    return (
        <>
            <button type='button' className={props.className} onClick={handleClick}>
                <i className='fa-solid fa-language' />
                {t('header_language_button')}
                <i className='fa-solid fa-angle-down' />
            </button>

            <Menu
                id='basic-menu-language'
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {projectInfo.data && projectInfo.data.type !== undefined && projectInfo.data.type !== EProjectType.Macra1 ? (
                    <MenuItem className={props.className} onClick={() => handleClose(ELanguages.en)}>
                        {languages[ELanguages.en as TLanguages]}
                    </MenuItem>
                ) : (
                    Object.keys(ELanguages).map((language, i) => (
                        <MenuItem className={props.className} onClick={() => handleClose(language)} key={`language_MenuItem_${i}`}>
                            {languages[language as TLanguages]}
                        </MenuItem>
                    ))
                )}
            </Menu>
        </>
    );
};

export default LanguageButton;
